import { TIdForCTM, TTableColumn } from "../../types";
import CustomTableMaterial from "../../shared/table/customTableMaterial";
import { RowsPerPageEnum } from "../../displayColumnsConfig";

export const tableColumns: TTableColumn[] = [
  {
    id: "name",
    label: "",
    minWidth: 50,
    align: "left",
  },
  {
    id: "amount",
    label: "количество",
    minWidth: 60,
    align: "right",
    format: (v): JSX.Element => {
      return v ? <span>{v}</span> : <span>0</span>;
    },
  },
  {
    id: "percentage",
    label: "в процентах",
    minWidth: 50,
    align: "left",
  },
];

interface TColType extends TIdForCTM {
  name: string;
  amount: string;
  percentage: string;
}

export default function Report83Table(props: { tableData: TColType[] }) {
  let i = 1;
  props.tableData.forEach((r) => {
    if (!r.id) r["id"] = i++;
  });

  return (
    <CustomTableMaterial<TColType>
      list={props.tableData || []}
      columns={tableColumns}
      page={0}
      rowsPerPage={RowsPerPageEnum.ALL}
      localPagination={true}
    />
  );
}
